import * as React from "react";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

interface IQualifyModal {
  readonly open: boolean;
  readonly handleClose: () => void;
  readonly handleRelease: (sendMail: boolean) => void;
  readonly handleDismiss: () => void;
}

export const QualifyModal = (props: IQualifyModal) => {
  const [mail, setMail] = useState(false);

  const handleMailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMail(event.target.checked);
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Ist der Bewerber Qualifiziert zur Freigabe?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <ul>
            <li>Hast du alle Daten geprüft?</li>
            <li>Erfüllt der Kandidat die Vorrausetzungen?</li>
          </ul>
        </DialogContentText>
        <FormControlLabel
          control={<Checkbox checked={mail} onChange={handleMailChange} />}
          label="Mail senden"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={props.handleDismiss}>
          Nicht Qualifiziert
        </Button>
        <Button variant="contained" onClick={() => props.handleRelease(mail)} autoFocus>
          Freigeben
        </Button>
      </DialogActions>
    </Dialog>
  );
};
